import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
import { Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PageHeader } from './PageHeader';

/** Screen planned for a later implementation phase (docs §24). Replace with the real feature page. */
export function PlaceholderPage({ titleKey, phase }: { titleKey: string; phase: number }) {
  const { t } = useTranslation(['menu', 'common']);
  return (
    <>
      <PageHeader title={t(titleKey)} />
      <Paper variant="outlined" sx={{ p: 6 }}>
        <Stack spacing={2} sx={{ alignItems: 'center', textAlign: 'center' }}>
          <ConstructionOutlinedIcon color="disabled" sx={{ fontSize: 56 }} />
          <Typography variant="h6">{t('common:placeholder.title')}</Typography>
          <Typography color="text.secondary">{t('common:placeholder.description', { phase })}</Typography>
        </Stack>
      </Paper>
    </>
  );
}
